<template lang="pug">
  app-button( @click.native="login" ) АИС Адвокатура
</template>

<script>
  export default {
    data: () => ({
      state: '',
      request: {},
      url_token: ''
    }),
    mounted() {
      let { protocol, hostname, port ='' } = window.location
      let host = `${protocol}//${hostname}${port && ':'}${port}`
      let redirect = host+'/extlogin/redirect/advocacy?';
      let state = this.uuid();
      this.state = state;
      this.request.redirect = redirect
      this.url_token = `http://int-apspb.dev2.nanbots.com:81/api/v1/oauth/authorize?response_type=code&scope=openid&client_id=sudportal&redirect_uri=${encodeURIComponent(redirect)}&state=${state}`
    },
    methods: {
      redirect(token) {
        this.request.token = token
        this.$emit('login', this.request, 'advocacy')
      },
      login() {
        let el = this;
        let height = window.innerHeight
        let width = window.innerWidth
        if (width > 500) width = 500
        if (height > 550) height = 550
        let left = window.innerWidth/2 - width/2
        let top = window.innerHeight/2 - height/2
        window.open(this.url_token, 'Вход через АИС Адвокатура', 'width=' + width + ',height=' + height + ',location=no,top=' + top + ',left=' + left)
        window.setAdvocacyToken = function(url) {
          let token = /code=([^&]+)/.exec(url)[1];
          let state = /state=([^&]+)/.exec(url)[1];
          if (el.state == state)
            el.redirect(token)
          else console.log('error state', el.state, state)
        }
      },
      uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      }
    }
  }
</script>
